import { createSlice, PayloadAction } from "@reduxjs/toolkit"

// will be id -> ms remaining
const initialState: Record<string, int> = {}

export const DownloadDisabledTimersSlice = createSlice({
	name: "downloadDisabledTimers",
	initialState,
	reducers: {
		add: (state, action: PayloadAction<{ id: string; ms: int }>) => {
			state[action.payload.id] = action.payload.ms
		},
		remove: (state, action: PayloadAction<string>) => {
			delete state[action.payload]
		},
	},
	selectors: {
		state: (s) => s,
	},
})
